import { FetchProxy } from "intraactive-sdk-helper";
import { IEnvironment } from "../interfaces/IEnvironment";
import { Environment } from "./Environment";
import { sdkContainerInstance } from "../global/Container";
import { ITemplate } from "../interfaces/templates/ITemplate";

export default class EventTemplateService {
  public static getAllTemplates(environment: IEnvironment, tenant: string, instanceName: string): Promise<{templates: ITemplate[]}> {
    return new Promise<{templates: ITemplate[]}>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForEventsAPI(environment)}/${tenant}/templates/${instanceName}/all`;
        new FetchProxy(apiUrl,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static getTemplatesForUser(environment: IEnvironment, tenant: string, instanceName: string): Promise<{templates: ITemplate[]}> {
    return new Promise<{templates: ITemplate[]}>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForEventsAPI(environment)}/${tenant}/templates/${instanceName}/user`;
        new FetchProxy(apiUrl,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }
  
  public static createOrUpdateTemplate(environment: IEnvironment, tenant: string, instanceName: string, template: ITemplate): Promise<ITemplate> {
    return new Promise((resolve, reject): void => {
      if (environment && tenant) {
        const method = !!template.id ? "PUT" : "POST"; // if the template has an ID, it's an update call. Else it's an create call
        let apiUrl = `${Environment.getEnvironmentForEventsAPI(environment)}/${tenant}/templates/${instanceName}/all`;
        new FetchProxy(apiUrl,
          {
            method: method,
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(template)
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static getTemplate(environment: IEnvironment, tenant: string, instanceName: string, id: string): Promise<ITemplate> {
    return new Promise<ITemplate>((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForEventsAPI(environment)}/${tenant}/templates/${instanceName}/${id}`;
        new FetchProxy(apiUrl,
          {
            method: "GET",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              return response.json();
            }
          }).then(response => {
            resolve(response);
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }

  public static deleteTemplate(environment: IEnvironment, tenant: string, instanceName: string, id: string): Promise<void> {
    return new Promise((resolve, reject): void => {
      if (environment && tenant) {
        let apiUrl = `${Environment.getEnvironmentForEventsAPI(environment)}/${tenant}/templates/${instanceName}/${id}`;
        new FetchProxy(apiUrl,
          {
            method: "DELETE",
            headers: {
              'Content-Type': 'application/json'
            }
          })
          .withContainer(sdkContainerInstance)
          .fetch()
          .then((response) => {
            if (!response.ok) {
              throw (response.status);
            } else {
              resolve();
            }
          })
          .catch(error => {
            console.log(error);
            reject(null);
          });
      } else {
        reject(null);
      }
    });
  }
}